/* eslint-disable @intercom/intercom/no-bare-strings */

import { guidFor } from '@ember/object/internals';
import { uploadResultToNodeAttrs } from '@intercom/embercom-prosemirror-composer/lib/config/specs/decorators';
import { applyNewAttrsToFileNode, findNodeByFileGUID } from '@intercom/embercom-prosemirror-composer/lib/helpers/file';
export function updateVideoFileNodeWithDurationAndUploadResults({
  editorView,
  duration,
  thumbnailUploadResult,
  videoUploadResult
}) {
  let pos = findNodeByFileGUID(editorView, guidFor(videoUploadResult.file));
  if (pos.fileNode) {
    let attrs = {
      ...pos.fileNode.attrs
    };
    let failure = [videoUploadResult, thumbnailUploadResult].find(r => r.type !== 'success');
    if (failure) {
      attrs = {
        ...attrs,
        ...uploadResultToNodeAttrs(failure)
      };
    } else if (videoUploadResult.type === 'success' && thumbnailUploadResult.type === 'success') {
      attrs = {
        ...attrs,
        ...uploadResultToNodeAttrs(videoUploadResult),
        thumbnailUrl: thumbnailUploadResult.uploadUrl,
        url: videoUploadResult.uploadUrl
      };
    }
    attrs.duration = duration;
    applyNewAttrsToFileNode(editorView, pos, attrs);
  }
}

// This was ported from the legacy composer, see https://github.com/intercom/embercom-composer/blob/master/addon/lib/video-metadata.js
export function determineVideoMetadata(file) {
  return new Promise(function (resolve, reject) {
    let video = document.createElement('video');
    let reader = new FileReader();
    let onError = function (event) {
      reject({
        error: event,
        message: getErrorMessage(event)
      });
    };
    video.addEventListener('error', onError);
    video.addEventListener('loadeddata', () => {
      let thumbnailDataUrl = createThumbnailDataUrl(video);
      resolve({
        duration: video.duration,
        thumbnailDataUrl
      });
    });
    reader.addEventListener('error', onError);
    reader.addEventListener('load', () => {
      video.setAttribute('preload', 'auto');
      video.src = reader.result;
    });
    reader.readAsDataURL(file);
  });
  function createThumbnailDataUrl(video) {
    let canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    let context = canvas.getContext('2d');
    if (context) {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/jpg');
    } else {
      return '';
    }
  }
  function getErrorMessage(event) {
    let errorMessage = 'Failed to load video';
    if (isMediaDemuxerError(event)) {
      errorMessage += ' - Encoding error';
    }
    return errorMessage;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function isMediaDemuxerError(event) {
    return event && event.path && event.path.length && event.path[0].error && event.path[0].error.message === 'DEMUXER_ERROR_COULD_NOT_OPEN: FFmpegDemuxer: open context failed';
  }
}